import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useLanguage();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setError(t('auth.invalidResetLink'));
    }
  }, [token, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== passwordConfirmation) {
      setError(t('auth.passwordsDoNotMatch'));
      return;
    }

    if (password.length < 6) {
      setError(t('auth.passwordTooShort'));
      return;
    }

    setLoading(true);

    try {
      const language = localStorage.getItem('language') || 'en';
      const response = await axios.put(`/api/password_resets/${token}`, {
        password,
        password_confirmation: passwordConfirmation,
        language
      });
      setMessage(response.data.message);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.errors?.join(', ') || t('auth.passwordResetFailed'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="error-message">{t('auth.invalidResetLink')}</div>
        <div className="auth-link">
          <a onClick={() => navigate('/login')}>{t('auth.backToLogin')}</a>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <h1 className="auth-title">{t('auth.resetPassword')}</h1>
      <p className="auth-subtitle">{t('auth.resetPasswordSubtitle')}</p>

      {error && <div className="error-message">{error}</div>}
      {message && <div className="success-message">{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="password">{t('auth.newPassword')}</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('auth.enterNewPassword')}
            required
            minLength={6}
          />
        </div>

        <div className="form-group">
          <label htmlFor="passwordConfirmation">{t('auth.confirmPassword')}</label>
          <input
            id="passwordConfirmation"
            type="password"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            placeholder={t('auth.confirmNewPassword')}
            required
            minLength={6}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? t('auth.resetting') : t('auth.resetPasswordButton')}
        </button>
      </form>

      <div className="auth-link">
        <a onClick={() => navigate('/login')}>{t('auth.backToLogin')}</a>
      </div>
    </div>
  );
};

export default ResetPassword;